<template>
  <div
    class="alert alert-warning"
    :class="{
      'd-inline-block ms-1 me-1 p-0 ps-1 pe-1': displayInline,
      'p-2': !displayInline,
    }"
  >
    <div>
      <strong>
        {{ $t("rotaActivity.report.behaviour") }}:
        <span class="badge bg-secondary">
          {{ report.type }}
        </span>
      </strong>
      <button
        v-if="displayInline && report.incident && !report.incident.reportFiled"
        class="ms-1 m-1 btn btn-outline-primary btn-sm"
        @click="fileReporBtn"
      >
        <font-awesome-icon icon="info-circle" />
        Report needs to be filed ...
      </button>
    </div>
    <template v-if="!displayInline && report.incident">
      <template v-if="report.incident">
        <button
          v-if="report.incident.reportFiled"
          class="ms-1 m-1 btn btn-success btn-sm float-end"
          disabled
        >
          <font-awesome-icon icon="check" /> Report Filed
          {{ formatModifiedDate(report.incident.reportFiled) }}
        </button>
        <button
          v-if="!report.incident.reportFiled"
          class="btn btn-outline-primary btn-sm float-end mt-1"
          @click="fileReporBtn"
        >
          <font-awesome-icon icon="info-circle" />
          Report needs to be filed ...
        </button>
      </template>
      <!-- location -->
      <div>
        Occurred
        {{ report.incident.inHome ? "in the home" : "in the community" }}
        <span v-if="report.incident.subLocation"
          >({{ report.incident.subLocation }})</span
        >
        at {{ formatTimeHoursMins(report.eventDate) }}
      </div>
      <div v-if="report.incident.staffIntervened">Staff Intervened</div>
      <div v-if="report.incident.otherStaff">
        {{ report.incident.otherStaff.length }} other staff involved:
        <span v-for="staffId in report.incident.otherStaff" :key="staffId">
          <user-display-resolver :user-id="staffId" :scale="0.5" class="me-1" />
        </span>
      </div>
      <!-- other clients -->
      <div v-if="report.incident.otherClients" class="placeholder-glow">
        {{ report.incident.otherClients.length }} other clients involved:
        <template v-if="allClients.length > 0">
          <client-badge
            v-for="client in report.incident.otherClients"
            :key="client"
            :client="getClientById(client)"
            :all-clients="allClients"
            :show-room-number="true"
            class="me-2"
          />
        </template>
        <span v-else class="placeholder col-2" aria-hidden="true" />
      </div>
      <p v-if="report.incident.note" class="mb-0 mt-1">
        Incident note: {{ report.incident.note }}
      </p>
    </template>
  </div>
</template>

<script>
import { ref } from "vue";
import { useStore } from "vuex";
import ClientBadge from "@/components/ui/ClientBadge.vue";
import UserDisplayResolver from "@/components/UserDisplayResolver.vue";
import { formatModifiedDate, formatTimeHoursMins } from "@/lib/date-functions";
import useFileChallengingBehaviourReportModal from "../modal/useFileChallengingBehaviourReportModal";

export default {
  name: "ChallengingBehaviourRenderItem",
  components: {
    ClientBadge,
    UserDisplayResolver,
  },
  props: {
    report: {
      type: Object,
      required: true,
    },
    activityId: {
      type: String,
      required: true,
    },
    clientId: {
      type: String,
      required: true,
    },
    displayInline: {
      type: Boolean,
      default: false,
    },
  },
  setup: (props) => {
    const store = useStore();
    const allClients = ref([]);

    const { showModal } = useFileChallengingBehaviourReportModal();

    store.dispatch("clients/getAllClients").then((data) => {
      if (data !== false) {
        allClients.value = data;
      }
    });

    const getClientById = (id) => {
      return allClients.value.find((client) => client.id === id);
    };

    return {
      allClients,
      getClientById,
      formatModifiedDate,
      formatTimeHoursMins,
      fileReporBtn: () => {
        showModal(props.activityId, props.clientId, props.report);
      },
    };
  },
};
</script>
